






import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Flip from './Flip.vue';

@Component({
  name: 'DigitalFlipper',
  components: {
    Flip,
  },
})
export default class DigitalFlipper extends Vue {
  @Prop({ default: '0000' }) readonly total!: string; // 过渡时间（时间间隔）

  digits: number[] = [];

  @Watch('total', { immediate: true })
  onTotalChange() {
    let num = this.total;
    if (num.length < 4) num = '00' + num;
    this.digits = num.split('').map(Number);
  }

  mounted() {
    this.onTotalChange();
  }
}
